// extracted by mini-css-extract-plugin
export default {"hideTooltip":"K_-z","fadeIn":"L_-z","delay":"M_-z","recommendedSizeTooltip":"N_-z"};